'use strict';
import classNames from 'classnames';
import moment from 'moment';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import BigCalendar from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import errorIcon from '../../../../img/error.svg';
import loadingIcon from '../../../../img/loading.svg';
import noNetworkIcon from '../../../../img/no-network.svg';
import {Button} from '../../../components/buttons/Button';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {ViewMode, ViewModePropType} from '../../../core-utilities/enums/ViewMode';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {Event} from '../Event';
import {EventAgenda} from '../EventAgenda';


BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const COMPONENTS = {
  event: Event,
  agenda: {
    event: EventAgenda,
  },
};

export const CalendarView = {
  month: 'month',
  week: 'week',
  day: 'day',
  agenda: 'agenda',
};

const CalendarScrollClass = {
  month: 'scrollarea-month',
  week: 'scrollarea-week',
  day: 'scrollarea-day',
  agenda: 'scrollarea-agenda',
};

export function BaseOrgCalendarView(props) {
  const scrollClass = CalendarScrollClass[props.currentView];

  return (
    <ProjectLayout
      className={classNames("PersonnelViewOverview", props.className)}
      title={props.viewTitle}
      useScroll={false}
      showBackButton={false}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={false}
      headerRightContent={(
        <Fragment>
          <Button
            className="PersonnelViewOverview__headerButton"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </Fragment>
      )}
      navBarContent={null}
      bannerContent={null}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
    >
      <div className="ProjectLayout__scrollArea">
        <div className="ProjectLayout__scroll org-calendar-view">
          <div className={`org-calendar-container ${scrollClass}`}>
            {renderOverlay(props)}
            <BigCalendar
              className="org-calendar-component"
              events={props.events}
              defaultDate={props.defaultDate}
              popup={true}
              eventPropGetter={props.eventPropGetter}
              components={COMPONENTS}

              onNavigate={props.onNavigate}
              onView={props.onView}
              onSelectEvent={props.onSelectEvent}
            />
          </div>
        </div>
      </div>
    </ProjectLayout>
  );
}

function renderOverlay(props) {
  switch (props.mode) {
    case ViewMode.LOADING:
      // Actual source: img/loading.svg
      // svg is in-lined otherwise there is a lag when initially loading the calendar and some errors (like not online) may result in failing to load the icon. plus this saves a request.
      // if src/img/loading.svg is modified, for now, it must be manually updated here as well.
      return (
        <div className="org-calendar-overlay-loading">
          <div className="status-container">
            <img
              className="status-image"
              src={loadingIcon}
            />
            <div className="status-message">
              Loading
            </div>
          </div>
        </div>
      );
    case ViewMode.SUCCESS:
      return '';
    case ViewMode.ENONET:
      // Actual source: img/no-network.svg
      // if src/img/no-network.svg is modified, for now, it must be manually updated here as well.
      return (
        <div className="org-calendar-overlay-loading">
          <div className="status-container">
            <img
              className="status-image"
              src={noNetworkIcon}
            />
            <div className="status-message">
              The server could not be reached.
            </div>
          </div>
        </div>
      );
    case ViewMode.EOTHER:
      // consider displaying the error message to the user
      // Actual source: img/error.svg
      // if src/img/error.svg is modified, for now, it must be manually updated here as well.
      return (
        <div className="org-calendar-overlay-loading">
          <div className="status-container error-status">
            <img
              className="status-image"
              src={errorIcon}
            />
            <div className="status-message">
              An error occurred.
            </div>
          </div>
        </div>
      );
  }
}

BaseOrgCalendarView.propTypes = {
  className: T.string,
  currentView: T.string,
  mode: ViewModePropType,
  events: T.array,
  defaultDate: T.instanceOf(Date),
  eventPropGetter: T.func,
  onNavigate: T.func,
  onView: T.func,
  onSelectEvent: T.func,

  viewTitle: T.string,
};

BaseOrgCalendarView.defaultProps = {
  events: [],
  currentView: CalendarView.month,
};

export const OrgCalendarView = I18nComponent(BaseOrgCalendarView, [
  {code: 'organizations.calendar.title', prop: 'viewTitle'},
]);



// WEBPACK FOOTER //
// ./src/js/calendar/components/OrgCalendar/OrgCalendarView.js